import { createResource, RouterContext } from 'react-resource-router';

import workspaceUrls from 'src/sections/workspace/urls';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

const defaultPage = 1;

export type DeactivatedWorkspaceAccess = {
  type: 'workspace_access';
  administrator: boolean;
  workspace: {
    type: 'workspace_base';
    uuid: string;
    slug: string;
    links: {
      avatar: { href: string };
      self: { href: string };
    };
    is_personal: boolean;
  };
};

export type DeactivatedWorkspacesData = {
  pagelen: number;
  size: number;
  page: number;
  values: DeactivatedWorkspaceAccess[];
};

export const accountDormantWorkspacesPartOfWsCleanupResource = createResource({
  type: 'ACCOUNT_DORMANT_WORKSPACES_PART_OF_WS_CLEANUP',
  getKey: ({ query }: RouterContext) =>
    `account-dormant-workspaces-part-of-ws-cleanup:${query?.page || '1'}`,
  maxAge: 60 * 1000,
  getData: async ({ query }): Promise<DeactivatedWorkspacesData | null> => {
    const page = Number(query?.page) || defaultPage;
    const response = await fetch(
      authRequest(workspaceUrls.api.internal.dormantWorkspaces(page), {
        headers: jsonHeaders,
      })
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching workspaces (${response.status}): ${response.statusText}`
      );
    }

    const deactivatedWorkspaces: DeactivatedWorkspacesData =
      await response.json();

    return deactivatedWorkspaces;
  },
});
